module.exports = __webpack_public_path__ + "static/media/demo_image_1.6dc43bdf.png";